<script>
  import Breadcrumbs from '$components/Breadcrumbs/Breadcrumbs.svelte';
  import PharmacyLocationInformation from '$components/PharmacyLocationInformation/PharmacyLocationInformation.svelte';
  import DrugSavingsList from '$components/DrugSavingsList/DrugSavingsList.svelte';
  import PharmacyLocations from '$components/PharmacyLocations/PharmacyLocations.svelte';
  import ExtendedPharmaciesList from '$components/ExtendedPharmaciesList/ExtendedPharmaciesList.svelte';

  let { data } = $props();
</script>

<Breadcrumbs
  crumbsText={data.crumbsText}
  path={data.path}
  paginationPage={data.paginationPage}
  pharmacyLocationPage={true}
/>

<div class="bg-blue-very-light">
  <div class="max-w-6xl p-4 mx-auto md:py-8 xl:py-10">
    <PharmacyLocationInformation {...data.pharmacyLocationInformation} {...data.pharmacy} headingLevel="h1" />
  </div>
</div>
<div class="px-4 py-6 md:py-8 mx-auto max-w-6xl">
  <DrugSavingsList {...data.drugSavingsList} lang={data.lang} />
</div>
<div
  class="grow bg-gray-mercury w-full py-8 lg:py-12 shadow-content-well"
  class:pt-0={!data.pharmaciesCondensed.length}
  class:lg:pt-4={!data.pharmaciesCondensed.length}
>
  {#if data.pharmaciesCondensed.length}
    <PharmacyLocations
      {...data.pharmacyLocations}
      pharmacies={data.pharmaciesCondensed}
      noImage="true"
      fullWidth="true"
    />
  {/if}
  {#if data.extendedPharmaciesList}
    <div class="lg:mt-4">
      <ExtendedPharmaciesList {...data.extendedPharmaciesList} count="0" pharmacies="" />
    </div>
  {/if}
</div>
